<template src="./Terapias.html"></template>

<script>
import { crearFormulario } from "../../apiService/request/CrudFormulario";
import { consultarEstructuraCuestionarioPorId } from "../../apiService/request/CrudSeguimiento";
import {
  leerEsquemaSeleccionTerapia,
  leerTerapias,
  crearTerapia,
} from "../../apiService/request/CrudTerapias";
import TerapiasPaciente from "./TerapiasPaciente/TerapiasPaciente";
import TerapiasEsquema from "./TerapiasEsquema/TerapiasEsquema";
import MensajesMasivos from "../MensajesMasivos/MensajesMasivos";
import Listas from "../Listas/Listas.vue";
export default {
  data() {
    return {
      contentIndex: 0,
      drawer: true,
      items: [
        {
          title: "Pacientes",
          icon: "mdi-account-outline",
          link: "/terapias/pacientes",
        },
        {
          title: "Esquemas",
          icon: "mdi-medical-bag",
          link: "/terapias/esquemas",
        },
        {
          title: "Mensajes masivos",
          icon: "mdi-message-text-outline",
          link: "/terapias/masivos",
        },
        {
          title: "Listas",
          icon: "mdi-calendar-text-outline",
          link: "/terapias/Listas",
        },
      ],
      color: "#0B3352",
      right: true,
      permanent: true,
      miniVariant: false,
      expandOnHover: false,
      background: false,

      banderaMostrarSidebar: false,
      variablesInforGeneral: null,
      docsTerapias: null,
      textoSeleccionTerapia:
        "Seleccione la terapia que desea agregar al paciente",
    };
  },
  computed: {
    objectFit() {
      return this.miniVariant ? "contain" : null;
    },
  },
  methods: {
    setNavContentIndex(contentIndex) {
      this.contentIndex = contentIndex;
    },
    async agregarTerapia() {
      const respuesta = await crearTerapia(
        this.docsTerapias.valor,
        Number(this.documentoPaciente),
        "sesiones",
        "julianl@neumomed.com"
      );
    },
  },
  props: ["valorSeleccionadoDialogo"],
  async mounted() {},
  components: {
    TerapiasPaciente,
    TerapiasEsquema,
    MensajesMasivos,
    Listas,
  },
};
</script>

<style lang="scss" src="./Terapias.scss" scoped></style>



// WEBPACK FOOTER //
// src/components/Terapias/Terapias.vue